import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'

import { quizKeys } from 'components/Quiz/Revamp/constants'
import { featureTypes } from 'constants/mydrive'
import {
    emitToggleMyDrive,
    myDriveEventEmitter,
    myDriveKeys,
} from 'helpers/events'
import { dispatchSendSocketMessage, dispatchSetQuizId } from 'store/dispatcher'
import { _quizId } from 'store/selectors/Quiz'
import { _isStudent } from 'store/selectors/User'
import { _websocketMsg } from 'store/selectors/WebSocket'

export default function useQuiz({
    isQuizMode,
    isArtefactMode,
    setQuizMode,
    setWhiteboardMode,
    setArtefactMode,
}) {
    const msg = useSelector(_websocketMsg)
    const quizId = useSelector(_quizId)

    const [showQuizEndPopUp, setShowQuizEngPopUp] = useState(false)
    const toggleQuizEndPopUp = () => setShowQuizEngPopUp(!showQuizEndPopUp)

    const _setQuizId = quizId => dispatchSetQuizId(quizId)

    const isStudent = useSelector(_isStudent)

    const isQuizDisabled = (isArtefactMode && !isQuizMode) || isStudent

    useEffect(() => {
        const toggle = () => {
            setQuizMode(isQuizMode => !isQuizMode)
        }

        myDriveEventEmitter.addListener(myDriveKeys.TOGGLE_QUIZ, toggle)

        return () => {
            myDriveEventEmitter.removeListener(myDriveKeys.TOGGLE_QUIZ, toggle)
        }
    }, [])

    const cancelQuiz = () => {
        dispatchSendSocketMessage({
            action: quizKeys.QUIZ_CANCEL,
            quiz: quizId,
        })
        _setQuizId('')
    }

    const toggleQuiz = () => {
        if (isQuizDisabled) return

        if (isQuizMode) {
            if (quizId) {
                // ask for cancel confirmation
                toggleQuizEndPopUp()
            } else {
                setArtefactMode(!isQuizMode)
                setQuizMode(!isQuizMode)
            }
        } else {
            emitToggleMyDrive({ state: true, type: featureTypes.QUIZ })
        }
    }

    useEffect(() => {
        if (msg?.action === quizKeys.QUIZ) {
            _setQuizId(msg.message.quiz)
        }
    }, [msg, _setQuizId])

    return {
        isQuizMode,
        toggleQuiz,
        isQuizDisabled,
        showQuizEndPopUp,
        toggleQuizEndPopUp,
        cancelQuiz,
    }
}
